import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { ICancelReason } from 'interfaces/cancelReason';

const useCancelReason = () => {
  const { data, error } = useSWR(
    ['/appointments/cancel-reasons'],
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<ICancelReason[]>(url);
      return response.data;
    }
  );

  const normalizedData = data
    ? data.map((item) => ({
        id: item.code,
        description: item.description,
      }))
    : [];

  return {
    data: normalizedData,
    error,
    isLoading: !data && !error,
  };
};

export default useCancelReason;
